import * as React from 'react';

// Touch screens only: after the keyboard has had time to open, scrolls a focused
// field into the visible area, but only if it is behind the keyboard or under
// the sticky header, so a field that is already in view never jumps (design
// build_hints.md > All steps > Mobile field focus). Attached to the flow's own
// root, so it never reacts to a field elsewhere on the page.
const FIELD = 'input, textarea, select, [role="combobox"]';

export default function useFieldLift(rootRef) {
  React.useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    let timer;
    const onFocusIn = (e) => {
      const el = e.target;
      if (!el || !el.matches || !el.matches(FIELD)) return;
      if (!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (document.activeElement !== el) return;
        const vv = window.visualViewport;
        const top = vv ? vv.offsetTop : 0;
        const height = vv ? vv.height : window.innerHeight;
        const head = document.querySelector('.ec-header');
        const visTop = top + (head ? head.getBoundingClientRect().height : 0);
        const visBottom = top + height;
        const r = el.getBoundingClientRect();
        if (r.bottom <= visBottom - 24 && r.top >= visTop + 8) return;
        window.scrollBy({ top: (r.top + r.height / 2) - (visTop + visBottom) / 2, behavior: 'smooth' });
      }, 250);
    };
    root.addEventListener('focusin', onFocusIn);
    return () => { clearTimeout(timer); root.removeEventListener('focusin', onFocusIn); };
  }, [rootRef]);
}
